import { Outlet } from "react-router-dom";
import AdminMenu from "components/bo/adminMenu/AdminMenu";
import { useUserContext } from "api/user/UserProvider";
import { canUserPerformAction } from "access-roles/general-functions";
import { ROLE_ADMIN, ROLE_RGP } from "access-roles/roles";
import { ROLE_MATCH_MODE } from "constants/constants";

const Admin = () => {
  const { userRoleList } = useUserContext();

  const isAdmin = canUserPerformAction({
    userRoles: userRoleList,
    requiredRoles: [ROLE_ADMIN, ROLE_RGP],
    mode: ROLE_MATCH_MODE.OR,
  });
  if (!isAdmin) {
    return null;
  }

  return (
    <>
      <AdminMenu />
      <br />
      <Outlet />
    </>
  );
};

export default Admin;
